import { ENGLISH_TRANSLATIONS } from './translation/en'
import { GERMAN_TRANSLATIONS } from './translation/de'
import { FRENCH_TRANSLATIONS } from './translation/fr'
import { ITALIAN_TRANSLATIONS } from './translation/it'
import { DUTCH_TRANSLATIONS } from './translation/nl'
import { CHINESE_TRANSLATIONS } from './translation/zh'
import { CANADA_TRANSLATIONS } from './translation/ca'

export default {
  supported_languages: {
    de: GERMAN_TRANSLATIONS,
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
    it: ITALIAN_TRANSLATIONS,
    nl: DUTCH_TRANSLATIONS,
    ca: CANADA_TRANSLATIONS,
    zh: CHINESE_TRANSLATIONS
  }
}
